<div class="pipeline-layers-console">
  <!-- Camadas em cards: título, badge X/Y, ícone relógio + tempo -->
  @if (isLoading() || layersList().length > 1) {
  <div class="layers-summary" [appSkeleton]="isLoading()">
    @if (isLoading() && layersList().length === 0) {
      @for (title of layerSkeletonPlaceholders; track title; let i = $index) {
      @if (i > 0) {
      <div class="connector-h" aria-hidden="true"></div>
      }
      <app-pipeline-stage-card [title]="title" status="notDone" [showStats]="false" [disabled]="true">
      </app-pipeline-stage-card>
      }
    } @else {
      @for (layer of layersList(); track layer._id ?? layer.layer ?? $index; let i = $index) {
      @if (i > 0) {
      <div class="connector-h" aria-hidden="true"></div>
      }
      <app-pipeline-stage-card [title]="mapLayerNames[layer.layer]" [status]="layer.status" [isLoading]="layer.isLoading"
        [isSelected]="selectedLayerId() === layer._id" [steps]="layer.steps" [showStats]="false"
        (cardClick)="openConsole(layer)" [disabled]="layer.status !== 'processing' && layer.status !== 'completed' && layer.status !== 'failure' && layer.status !== 'initializing'">
      </app-pipeline-stage-card>
      }
    }
  </div>
  }

  <!-- Painel de logs (visível quando há camada com falha selecionada) -->
  @if (isConsoleOpen()) {
  <div class="console-panel">
    <div class="console-logs-header">
      <span class="console-logs-label">Logs da execução</span>
    </div>
    <div class="console-logs-body">
      @for (line of logs(); track $index) {
      <div class="console-log-line" [class.log-line--error]="line.status === 'failure'"
        [class.log-line--success]="line.status === 'completed'">
        {{ line.message }}
      </div>
      }
    </div>
    <!-- <div class="console-footer">
      <span class="console-footer-time">
        Tempo total decorrido: <strong>{{ selectedLayer()?.duration ?? '0s' }}</strong>
      </span>
    </div> -->
  </div>
  }
</div>
